import { useTranslate } from 'ra-core'

const AdCreativeTitle = ({ record }: { record?: { name?: string } }) => {
  const translate = useTranslate()
  return (
    <span>
      {translate('Ad Creative')} - {record && record.name ? `"${record.name}"` : ''}
    </span>
  )
}

export default {
  list: { lazy: () => import('./AdCreativeList') },
  edit: { lazy: () => import('./AdCreativeEdit') },
  create: { lazy: () => import('./AdCreativeCreate') },
  options: {
    create: {
      title: 'Create Ad Creative',
      subtitle: null,
      breadCrumb: 'Create Ad Creative',
    },
    list: {
      title: 'Ad Creatives',
      subtitle: null,
      breadCrumb: 'Ad Creatives',
    },
    edit: {
      title: <AdCreativeTitle />,
      subtitle: null,
      breadCrumb: 'Edit Ad Creative',
    },
  },
}
